export const MOST_POPULATED_TIMEZONES = Object.freeze([
  {
    label: 'Pacific/Midway (SST) -11:00',
    value: 'Pacific/Midway',
  },
  {
    label: 'Pacific/Honolulu (HST) -10:00',
    value: 'Pacific/Honolulu',
  },
  {
    label: 'Pacific/Marquesas (MART) -09:30',
    value: 'Pacific/Marquesas',
  },
  {
    label: 'America/Adak (HDT) -09:00',
    value: 'America/Adak',
  },
  {
    label: 'America/Anchorage (AKDT) -08:00',
    value: 'America/Anchorage',
  },
  {
    label: 'America/Los_Angeles (PDT) -07:00',
    value: 'America/Los_Angeles',
  },
  {
    label: 'America/Denver (MDT) -06:00',
    value: 'America/Denver',
  },
  {
    label: 'America/Mexico_City (CST) -06:00',
    value: 'America/Mexico_City',
  },

  {
    label: 'America/Chicago (CDT) -05:00',
    value: 'America/Chicago',
  },
  {
    label: 'America/Caracas (VET) -04:30',
    value: 'America/Caracas',
  },
  {
    label: 'America/New_York (EST) -04:00',
    value: 'America/New_York',
  },
  {
    label: 'America/Sao_Paulo (BRT) -03:00',
    value: 'America/Sao_Paulo',
  },
  {
    label: 'America/St_Johns (NDT) -02:30',
    value: 'America/St_Johns',
  },
  {
    label: 'America/Godthab (WGST) -02:00',
    value: 'America/Godthab',
  },
  {
    label: 'Atlantic/Cape_Verde (CVT) -01:00',
    value: 'Atlantic/Cape_Verde',
  },
  {
    label: 'Africa/Abidjan (GMT) +00:00',
    value: 'Africa/Abidjan',
  },
  {
    label: 'Africa/Bangui (WAT) +01:00',
    value: 'Africa/Bangui',
  },
  {
    label: 'Europe/London (BST) +01:00',
    value: 'Europe/London',
  },
  {
    label: 'Africa/Cairo (EET) +02:00',
    value: 'Africa/Cairo',
  },
  {
    label: 'Europe/Berlin (CEST) +02:00',
    value: 'Europe/Berlin',
  },
  {
    label: 'Asia/Jerusalem (GMT) +03:00',
    value: 'Asia/Jerusalem',
  },
  {
    label: 'Europe/Moscow (MSK) +03:00',
    value: 'Europe/Moscow',
  },
  {
    label: 'Asia/Dubai (GST) +04:00',
    value: 'Asia/Dubai',
  },
  {
    label: 'Asia/Tehran (IRDT) +04:30',
    value: 'Asia/Tehran',
  },
  {
    label: 'Asia/Karachi (PKT) +05:00',
    value: 'Asia/Karachi',
  },
  {
    label: 'Asia/Calcutta (IST) +05:30',
    value: 'Asia/Calcutta',
  },
  {
    label: 'Asia/Kathmandu (NPT) +05:45',
    value: 'Asia/Kathmandu',
  },
  {
    label: 'Asia/Dacca (BDT) +06:00',
    value: 'Asia/Dacca',
  },
  {
    label: 'Asia/Rangoon (MMT) +06:30',
    value: 'Asia/Rangoon',
  },
  {
    label: 'Asia/Jakarta (WIB) +07:00',
    value: 'Asia/Jakarta',
  },
  {
    label: 'Asia/Manila (PHT) +08:00',
    value: 'Asia/Manila',
  },
  {
    label: 'Asia/Pyongyang (KST) +08:30',
    value: 'Asia/Pyongyang',
  },
  {
    label: 'Australia/Eucla (ACWST) +08:45',
    value: 'Australia/Eucla',
  },
  {
    label: 'Asia/Tokyo (JST) +09:00',
    value: 'Asia/Tokyo',
  },
  {
    label: 'Australia/Adelaide (ACST) +09:30',
    value: 'Australia/Adelaide',
  },
  {
    label: 'Australia/ACT (AEST) +10:00',
    value: 'Australia/ACT',
  },
  {
    label: 'Australia/LHI (LHST) +10:30',
    value: 'Australia/LHI',
  },
  {
    label: 'Asia/Sakhalin (SAKT) +11:00',
    value: 'Asia/Sakhalin',
  },
  {
    label: 'Antarctica/McMurdo (NZST) +12:00',
    value: 'Antarctica/McMurdo',
  },
  {
    label: 'Pacific/Chatham (CHAST) +12:45',
    value: 'Pacific/Chatham',
  },
  {
    label: 'Pacific/Tongatapu (TOT) +13:00',
    value: 'Pacific/Tongatapu',
  },
  {
    label: 'Pacific/Kiritimati (LINT) +14:00',
    value: 'Pacific/Kiritimati',
  },
])

export const TIMEZONE_TO_ABBR = Object.freeze({
  'Pacific/Midway': 'SST',
  'Pacific/Honolulu': 'HST',
  'Pacific/Marquesas': 'MART',
  'America/Adak': 'HDT',
  'America/Anchorage': 'AKDT',
  'America/Los_Angeles': 'PDT',
  'America/Denver': 'MDT',
  'America/Mexico_City': 'CST',
  'America/Chicago': 'CDT',
  'America/Caracas': 'VET',
  'America/New_York': 'EST',
  'America/Sao_Paulo': 'BRT',
  'America/St_Johns': 'NDT',
  'America/Godthab': 'WGST',
  'Atlantic/Cape_Verde': 'CVT',
  'Africa/Abidjan': 'GMT',
  'Africa/Bangui': 'WAT',
  'Europe/London': 'BST',
  'Africa/Cairo': 'EET',
  'Europe/Berlin': 'CEST',
  'Asia/Jerusalem': 'GMT',
  'Europe/Moscow': 'MSK',
  'Asia/Dubai': 'GST',
  'Asia/Tehran': 'IRDT',
  'Asia/Karachi': 'PKT',
  'Asia/Calcutta': 'IST',
  'Asia/Kathmandu': 'NPT',
  'Asia/Dacca': 'BDT',
  'Asia/Rangoon': 'MMT',
  'Asia/Jakarta': 'WIB',
  'Asia/Manila': 'PHT',
  'Asia/Pyongyang': 'KST',
  'Australia/Eucla': 'ACWST',
  'Asia/Tokyo': 'JST',
  'Australia/Adelaide': 'ACST',
  'Australia/ACT': 'AEST',
  'Australia/LHI': 'LHST',
  'Asia/Sakhalin': 'SAKT',
  'Antarctica/McMurdo': 'NZST',
  'Pacific/Chatham': 'CHAST',
  'Pacific/Tongatapu': 'TOT',
  'Pacific/Kiritimati': 'LINT',
})
